define('../app/fukit/view/block/grouped.actions.container.view',['require','exports','module','uikit/uikit','../../helpers/extend.util','../../behavior/resolve.route.behavior'],function(require, exports, module) {
  //prettier-ignore
  var UIKit                = require('uikit/uikit'),
      ExtendUtil           = require('../../helpers/extend.util'),
      ResolveRouteBehavior = require('../../behavior/resolve.route.behavior');

  var GroupedActionsView = UIKit.ComponentsContainerView.extend({
    className: 'ui list',

    childView: UIKit.ComponentsContainerView.extend({
      className: 'item',
      components: [
        {
          type: UIKit.Button,
          name: 'button',
          fluid: true,
          behaviors: {
            ResolveRouteBehavior: {
              behaviorClass: ResolveRouteBehavior,
            },
          },
        },
      ],
    }),
  });

  var GroupedActionsContainerView = UIKit.ItemView.extend({
    className: 'grouped actions container',

    template: function() {
      return '<ui name="headerTextView" /><ui name="groupedActionsView" />';
    },

    internalViewOptions: {
      headerTextView: ExtendUtil.extendOptionValueWithDefaults('header', {
        type: UIKit.Header,
        tagName: 'h4',
      }),
      groupedActionsView: ExtendUtil.extendOptionValueWithDefaults('actions', {
        type: GroupedActionsView,
      }),
    },
  });

  module.exports = GroupedActionsContainerView;
});

